import React, { Component } from 'react';

class Intro extends Component {
    render() {
        return (
            <section className="pt-100 center-about bg-grey">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-heading text-center">
                                {/* Actualizado: texto genérico → "Experiencia técnica al servicio de la gente." */}
                                <span>Experiencia técnica al servicio de la gente.</span>
                                {/* Actualizado: texto genérico → cargo actual y trayectoria real */}
                                <h2>Más de dos décadas vigilando las finanzas públicas de Hidalgo, hoy como Regidora de Mineral de la Reforma.</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Intro;
